import $ from 'jquery';
import * as d3 from "d3";

export function cleanSvgIds(pid) {
    const liveViewId = `#project_live_view_chart_${pid}`;
    $(`${liveViewId}.project-live-view-chart text, ${liveViewId}.project-live-view-chart rect`).each(function (d) {
        var el_id = $(this).attr('id')
        if (el_id != undefined) {
            $(this).attr('id', el_id.replace(/_[0-9]+_/, ''))
        }
    })
}

export function insertDirectDisplayValues(item, pid) {
    const liveViewId = `#project_live_view_chart_${pid} `;
    let el = $(`${liveViewId}` + '[id="sensor-text-' + item['meterid'] + '"]').text(item['value_disp'])
    el = $(`${liveViewId}` + '[id="sensor-value-' + item['meterid'] + '"]').text(item['value_disp'])
    if (item['is_limit_exceeded'] == 1) {
        el.css('fill', 'red')
    }
}

/**
 * Calculate volume for horizontal cylindrical tank based on liquid height
 * Tank specs for PID 1327: 2.0M diameter × 5.5M length
 * 
 * Formula: V = L × [(A/π) × arccos((R-h)/R) - (R-h) × √(h(2R-h))]
 * Where:
 *   A = Cross-sectional area (πR²)
 *   L = Length of tank
 *   R = Radius (derived from A: R = √(A/π))
 *   h = Height of liquid level
 */
function calculateHorizontalCylindricalTankVolume(liquidHeight, radius, length) {
    const h = liquidHeight;
    const R = radius;
    const L = length;

    // Clamp h to valid range [0, 2R] (diameter)
    const hClamped = Math.max(0, Math.min(h, 2 * R));

    if (hClamped === 0) return 0;
    if (hClamped >= 2 * R) return Math.PI * R * R * L; // Full tank

    // V = L × [R² × arccos((R-h)/R) - (R-h) × √(h(2R-h))]
    const RMinusH = R - hClamped;
    const arccosTerm = Math.acos(RMinusH / R); // Returns radians
    const sqrtTerm = Math.sqrt(hClamped * (2 * R - hClamped));

    const volume = L * (R * R * arccosTerm - RMinusH * sqrtTerm);

    return volume; // in cubic meters
}

export function insertTankValues(item, pid) {
    const liveViewId = `#project_live_view_chart_${pid} `;
    var meterid = item['meterid']
    // Display curr level in the bottom
    var text_el = $(`${liveViewId}` + '[id="tank-value-quantity-' + meterid + '"]')
    
    // Variables for PID 1327 horizontal cylindrical tank
    let volumeLitres = null;
    let volumePercentage = null;
    
    if (pid === 1327 || pid === '1327') {
        // Horizontal cylindrical tank for PID 1327
        // Tank specs: 2.0M diameter × 5.5M length
        const TANK_RADIUS = 1.0;  // meters (diameter 2.0M / 2)
        const TANK_LENGTH = 5.5;  // meters
        const TANK_FULL_VOLUME = Math.PI * TANK_RADIUS * TANK_RADIUS * TANK_LENGTH; // Full tank volume in m³
        
        // Meter 68457 is the tank display, but meter 68458 has the raw sensor height in meters
        const TANK_DISPLAY_METER_ID = '68457';
        const RAW_HEIGHT_METER_ID = '68458';
        
        if (String(item['meterid']) === RAW_HEIGHT_METER_ID) {
            // Store the raw height in a global variable for use by meter 68457
            const rawHeight = parseFloat(item['value'] ?? item['value_disp']);
            window._pid1327_raw_height = rawHeight;
            
            // Also show in litres for this meter's own display if it has one
            const valueNum = parseFloat(item['value_disp']);
            if (!isNaN(valueNum)) {
                text_el.text((valueNum * 1000).toFixed(0) + 'L');
            }
            
            // If meter 68457 was already processed, update its display now
            if (window._pid1327_tank_element) {
                const volumeM3 = calculateHorizontalCylindricalTankVolume(rawHeight, TANK_RADIUS, TANK_LENGTH);
                const volLitres = volumeM3 * 1000;
                const volPercentage = (volumeM3 / TANK_FULL_VOLUME) * 100;
                const displayValue = volLitres.toFixed(0) + 'L';
                window._pid1327_tank_element.text(displayValue);
                
                // Update percentage display too
                if (window._pid1327_perc_element) {
                    window._pid1327_perc_element.text(volPercentage.toFixed(1) + '%');
                }
                // Store for tank fill visualization
                window._pid1327_volume_percentage = volPercentage;
            }
        } else if (String(item['meterid']) === TANK_DISPLAY_METER_ID) {
            // Store reference to tank display element for deferred update
            window._pid1327_tank_element = text_el;
            
            // Use the raw height from meter 68458 (stored in window._pid1327_raw_height)
            const liquidHeight = window._pid1327_raw_height;
            
            if (liquidHeight === undefined || isNaN(liquidHeight)) {
                // Raw height not available yet - show placeholder, will be updated when 68458 is processed
                const valueNum = parseFloat(item['value_disp']);
                text_el.text(isNaN(valueNum) ? 'NA' : (valueNum * 1000).toFixed(0) + 'L');
            } else {
                // Calculate volume using horizontal cylindrical tank formula
                const volumeM3 = calculateHorizontalCylindricalTankVolume(liquidHeight, TANK_RADIUS, TANK_LENGTH);
                volumeLitres = volumeM3 * 1000; // Convert m³ to litres
                volumePercentage = (volumeM3 / TANK_FULL_VOLUME) * 100; // Volume-based percentage
                const displayValue = volumeLitres.toFixed(0) + 'L';
                text_el.text(displayValue);
            }
        } else {
            // Other meters for PID 1327 - show in litres for their own display elements
            const valueNum = parseFloat(item['value_disp']);
            if (isNaN(valueNum)) {
                text_el.text('NA');
            } else {
                text_el.text((valueNum * 1000).toFixed(0) + 'L');
            }
        }
    } else {
        text_el.text(item['value_disp'] + 'KL');
    }

    // Display percentage on top of the tanker
    text_el = $(`${liveViewId}` + '[id="tank-value-percentage-' + meterid + '"]')
    var perc_disp;
    
    if (pid === 1327 || pid === '1327') {
        const TANK_DISPLAY_METER_ID = '68457';
        
        if (String(item['meterid']) === TANK_DISPLAY_METER_ID) {
            // Store reference to percentage element for deferred update
            window._pid1327_perc_element = text_el;
            
            // Check if we have the deferred percentage from meter 68458
            if (window._pid1327_volume_percentage !== undefined) {
                perc_disp = window._pid1327_volume_percentage.toFixed(1) + '%';
            } else if (volumePercentage !== null) {
                perc_disp = volumePercentage.toFixed(1) + '%';
            } else {
                // Placeholder - will be updated when 68458 is processed
                perc_disp = item['tank_curr_level_per'];
                perc_disp = perc_disp == undefined || perc_disp == 'NA' ? 'NA' : perc_disp.toFixed(1) + '%';
            }
        } else {
            // Other meters - use standard percentage
            perc_disp = item['tank_curr_level_per'];
            perc_disp = perc_disp == undefined || perc_disp == 'NA' ? 'NA' : perc_disp.toFixed(1) + '%';
        }
    } else {
        perc_disp = item['tank_curr_level_per'];
        perc_disp = perc_disp == undefined || perc_disp == 'NA' ? 'NA' : perc_disp.toFixed(1) + '%';
    }
    text_el.text(perc_disp)

    var el = $(`${liveViewId}` + '[id="tanker-rect-' + meterid + '"]')
    if (el.length > 0) {
        var obj_height = parseFloat(el.css('height').split('px')[0])
        // var obj_curr_x = parseFloat(el.css('x').split('px')[0])
        var obj_curr_y = parseFloat(el.css('y').split('px')[0])
        
        // Use volume-based percentage for PID 1327, otherwise use height-based
        var req_height;
        var effectivePercentage = null;
        
        if (pid === 1327 || pid === '1327') {
            // Check for deferred percentage first, then calculated, then fallback
            if (window._pid1327_volume_percentage !== undefined) {
                effectivePercentage = window._pid1327_volume_percentage;
            } else if (volumePercentage !== null) {
                effectivePercentage = volumePercentage;
            }
        }
        
        if (effectivePercentage !== null) {
            req_height = effectivePercentage / 100;
        } else {
            req_height = item['tank_curr_level_per'] / 100;
        }
        
        var obj_new_y = obj_curr_y + obj_height * (1 - req_height)
        var obj_new_height = obj_height - (obj_new_y - obj_curr_y)
        el.css('y', obj_new_y + 'px').css('height', obj_new_height + 'px')
        
        var fill = '#1a9850'
        var percentageForColor = effectivePercentage !== null 
            ? effectivePercentage 
            : item['tank_curr_level_per'];
            
        if (percentageForColor > 80) {
            fill = '#e46c49'
        } else if (percentageForColor < 20) {
            fill = '#C8B385'
        } else {
            fill = item['value_disp'] == 'NA' ? '#FFFFFF' : '#1a9850'
        }
        el.css('fill', fill)
        
        // Show tank capacity in tooltip
        var capacityText;
        if (pid === 1327 || pid === '1327') {
            const fullCapacityLitres = Math.PI * 1.0 * 1.0 * 5.5 * 1000; // ~17279 litres
            capacityText = 'Tank capacity: ' + Math.round(fullCapacityLitres) + ' L';
        } else {
            capacityText = 'Tank capacity: ' + Math.round(item['tank_capacity'], 1) + ' KL';
        }
        d3.select('[id="tanker-rect-' + meterid + '"]').append('title').text(capacityText)
    }
}

export function showWaterFlow(item, pid) {
    const liveViewId = `#project_live_view_chart_${pid} `;
    var meterid = item['meterid']
    if (item['metername'].includes('KL/hr')) {
        var el = $(`${liveViewId}` + '[id="flow-indicator-' + meterid + '"]')
        el.addClass('pipe-water-animate')
        if (item['value'] > 0) {
            el.addClass('pipe-water-animate')
        }
        else {
            el.removeClass('pipe-water-animate')
        }

    }
}

export function showLastUpdatedTime(item, pid) {
    const liveViewId = `#project_live_view_chart_${pid} `;
    var meterid = item['meterid']
    var text_el = $(`${liveViewId}` + '[id="sensor-last-updated-time-' + meterid + '"]')
    text_el.text(item['last_updated_time_display'])
    d3.select(`${liveViewId}` + '[id="sensor-last-updated-time-' + meterid + '"]')
        .append('svg:title').text(item['last_updated_time'])

}